export default __webpack_public_path__ + "static/media/76.f6f28647.jpeg";